import { getStaticPageFromPathname } from "@/config/staticPageVideoConfig";
import { getServerTemplateConfig } from "@/lib/serverTemplateDetection";

/** Mux fullscreen/modal player is open — consent must not cover the CTA. */
export const MUX_CTA_ACTIVE_EVENT = "mux-cta:active" as const;

export function isMuxCtaActiveInDom(): boolean {
  if (typeof document === "undefined") return false;
  return document.documentElement.dataset.muxCtaActive === "1";
}

export function isDualCtaConsentSurface(pathname: string): boolean {
  const serverCfg = getServerTemplateConfig();
  return (
    pathname === "/video-landing" ||
    serverCfg?.templateName === "DualCTAVideoLanding" ||
    serverCfg?.showDual === true
  );
}

export function isStaticMuxVideoPath(pathname: string): boolean {
  return getStaticPageFromPathname(pathname) !== null;
}

export function isHeroPriorityConsentSurface(pathname: string): boolean {
  return (
    pathname === "/" ||
    pathname === "/invitacion-premium" ||
    pathname === "/membresia-vip"
  );
}

export function hasPriorityHeroCta(): boolean {
  const serverCfg = getServerTemplateConfig();
  return !!(
    serverCfg?.showDual ||
    serverCfg?.showCheckout ||
    serverCfg?.showCommunity ||
    serverCfg?.showBirthday ||
    serverCfg?.showBestFriends ||
    serverCfg?.showWishlist
  );
}

/**
 * Pages where the fixed consent dock must not render at all (primary CTA owns the bottom).
 * DualCTA + home hero with Worker-driven CTA.
 */
export function shouldHidePublicConsentDock(pathname: string): boolean {
  // Passworded commercial deck owns the full black chrome (bottom nav).
  if (pathname === "/mediakit" || pathname.startsWith("/mediakit/")) return true;
  return (
    isDualCtaConsentSurface(pathname) ||
    (isHeroPriorityConsentSurface(pathname) && hasPriorityHeroCta())
  );
}

/** Longer delay on video-heavy surfaces so playback + CTA get first paint. */
export function getCookieConsentDelayMs(pathname: string): number {
  if (isStaticMuxVideoPath(pathname)) return 12_000;
  if (pathname === "/reels" || pathname.startsWith("/reel/")) return 10_000;
  if (isHeroPriorityConsentSurface(pathname)) return 6_000;
  return 4_000;
}

/** Compact single-row bar on narrow viewports (less intrusive than full-width sheet). */
export function prefersCompactConsentDock(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(max-width: 639px)").matches;
}
